module.exports = __webpack_public_path__ + "img/monster-gray-4.cb2a8d98.png";